<template>
  <div>
    <hr />
    <div class="mb-2 flex items-center">
      <i class="el-icon-info mr-[6px]"></i>
      <span class="font-medium">Sources:</span>
    </div>
    <div class="citation-container">
      <div
        class="citation-pill"
        v-for="(citation, index) in citations.data"
        @click="showCitationDetails(citation, index)"
        :key="index"
      >
        <span class="pill-text" v-if="loadingCitationIndex !== index">
          {{ citation.source }}
        </span>
        <div class="pill-text loading-animation" v-else>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </div>

    <GenAICitationModal
      v-if="selectedCitation"
      :visible="shouldShowModal"
      @closeModal="closeModal"
      :citation="selectedCitation"
      :showFullSource="citations.showFullSource"
    />
  </div>
</template>

<script>
import GenAICitationModal from "./GenAICitationModal.vue";
export default {
  name: "GenAICitations",
  props: ["citations"],
  data() {
    return {
      shouldShowModal: false,
      selectedCitation: null,
      loadingCitationIndex: null,
    };
  },
  components: {
    GenAICitationModal,
  },
  methods: {
    closeModal() {
      this.shouldShowModal = false;
      this.selectedCitation = null;
    },
    showCitationDetails(citation, index) {
      this.loadingCitationIndex = index;
      this.$store
        .dispatch("GET_CITATION_DETAILS", citation)
        .then((response) => {
          this.selectedCitation = {
            ...citation,
            ...response,
          };
          this.shouldShowModal = true;
        })
        .finally(() => {
          this.loadingCitationIndex = null;
        });
    },
  },
};
</script>

<style scoped>
.citation-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.citation-pill {
  background-color: #f2f3f5;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 14px;
  color: #333;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  max-width: 200px;
  min-width: 170px;
  overflow: hidden;
  cursor: pointer;
}

.pill-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  display: inline-block;
}

.year {
  margin-left: 6px;
  color: #666;
  font-weight: 500;
  flex-shrink: 0;
}

.loading-animation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  height: 18px;
  width: 100%;
  max-width: 100%;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #888;
  animation: bounce 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}
.dot:nth-child(2) {
  animation-delay: -0.16s;
}
.dot:nth-child(3) {
  animation-delay: 0;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
